import moment from 'moment';
import { IPlannedSurveyData } from 'modules/admin-panel/models';
import {
	IReminderFrequencyTypes,
	IRepetitiveTypes,
	ISlidersPayload,
	ISurveyRoundDurationTypes,
	ITemplateSchedulingData,
	IAppearanceFormNames,
	IExtremesSliderNames,
} from '../models';
import {
	parseExtremesToOptionList,
	GeneralSliderNames,
} from './parseExtremesToOptionList';

export function mapPlannedSurveyData(
	plannedSurveyData: IPlannedSurveyData,
): Partial<ITemplateSchedulingData> {
	const parsedWorkStyleExtremes = parseExtremesToOptionList(
		([] as ISlidersPayload[]).concat(
			plannedSurveyData.workStyleSlidersExtremes,
		),
	);
	const parsedPerformanceExtremes = parseExtremesToOptionList(
		([] as ISlidersPayload[]).concat(
			plannedSurveyData.performanceSlidersExtremes,
		),
	);

	return {
		schedulingFormData: {
			surveyName: plannedSurveyData.name,
			clientId: plannedSurveyData.clientId,
			partnerId: plannedSurveyData.partnerId,
			offices: plannedSurveyData.offices,
			sendRespondentCount: plannedSurveyData.sendRespondentCount,
			repetitiveType: plannedSurveyData.isRepeatable
				? IRepetitiveTypes.repetitive
				: IRepetitiveTypes.single,
			startDate: moment(plannedSurveyData.startDate),
			roundFrequency: plannedSurveyData.frequency,
			surveyDuration: plannedSurveyData.surveyDuration,
			surveyRoundDuration:
				plannedSurveyData.surveyRoundDuration === 1
					? ISurveyRoundDurationTypes.ONE_WEEK
					: ISurveyRoundDurationTypes.TWO_WEEKS,
			remindersFrequency: plannedSurveyData.isDailyReminders
				? IReminderFrequencyTypes.eachDay
				: IReminderFrequencyTypes.eachTwoDays,
			sendingTime: moment(plannedSurveyData.sendingTime, 'HH:mm:ss'),
		},
		appearanceFormData: {
			[IAppearanceFormNames.surveyInterface]: plannedSurveyData.surveyInterface,
			[IAppearanceFormNames.surveyRoles]: plannedSurveyData.roles,
			[IAppearanceFormNames.questionId]: plannedSurveyData.questionId,
			[IExtremesSliderNames.workStyleFirstSlider]:
				parsedWorkStyleExtremes[GeneralSliderNames.firstSlider][0].value,
			[IExtremesSliderNames.workStyleSecondSlider]:
				parsedWorkStyleExtremes[GeneralSliderNames.secondSlider][0].value,
			[IExtremesSliderNames.workStyleThirdSlider]:
				parsedWorkStyleExtremes[GeneralSliderNames.thirdSlider][0].value,
			[IExtremesSliderNames.performanceFirstSlider]:
				parsedPerformanceExtremes[GeneralSliderNames.firstSlider][0].value,
			[IExtremesSliderNames.performanceSecondSlider]:
				parsedPerformanceExtremes[GeneralSliderNames.secondSlider][0].value,
			[IExtremesSliderNames.performanceThirdSlider]:
				parsedPerformanceExtremes[GeneralSliderNames.thirdSlider][0].value,
		},
		servicesList: plannedSurveyData.services,
		templateId: plannedSurveyData.templateId,
	};
}
